import { render, staticRenderFns } from "./freemium.vue?vue&type=template&id=463eed50&scoped=true&"
import script from "./freemium.vue?vue&type=script&lang=js&"
export * from "./freemium.vue?vue&type=script&lang=js&"
import style0 from "./freemium.vue?vue&type=style&index=0&id=463eed50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463eed50",
  null
  
)

export default component.exports